import React, { useState } from 'react';
import '../../styles/gallery.css';

// Массив изображений
const images = [
  { id: 1, src: '/Gallery1.jpg', alt: 'Gallery Image 1' },
  { id: 2, src: '/Gallery2.jpg', alt: 'Gallery Image 2' },
  { id: 3, src: '/Gallery3.jpg', alt: 'Gallery Image 3' },
];

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (src) => {
    setSelectedImage(src);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery">
      <div className="responsive-container-block bigContainer">
        <div className="responsive-container-block Container">
          {images.map((image) => (
            <div className="project" key={image.id}>
              <img
                className="gallery-thumbnail" // Заменили класс smallImage на gallery-thumbnail
                src={image.src}
                alt={image.alt}
                onClick={() => openImage(image.src)}
              />
              <div className="btn-box">
                <button className="btn" onClick={() => openImage(image.src)}>
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="overlay" onClick={closeImage}>
          <div className="overlay-inner" onClick={(e) => e.stopPropagation()}>
            <button className="close" onClick={closeImage}>
              Close X
            </button>
            <div className="hdImgs">
              <img className="squareImg" src={selectedImage} alt="Selected" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
